import { DEFAULT_ENV } from './environment.default';

export const environment = {
  ...DEFAULT_ENV,
  production: true,
  firebase: {
    apiKey: 'AIzaSyAq5ldWHaUcNSLdvTVZLE19pg-vLV4qYPA',
    authDomain: 'park-demo-e5de1.firebaseapp.com',
    projectId: 'park-demo-e5de1',
    storageBucket: 'park-demo-e5de1.firebasestorage.app',
    messagingSenderId: '180088969579',
    appId: '1:180088969579:web:2021bbacaa030931ed542e'
  }
};
